import { CloseIcon } from '@chakra-ui/icons';
import { Box, Divider, Flex, IconButton, Text } from '@chakra-ui/react';
import { FileUploadingStatus } from 'enums/shared/fileUploadingStatus';
import { filesize } from 'filesize';
import { Color } from 'presentation/theme/colorScheme';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ChatUploadingFileThumbnail, {
  ChatUploadingFileThumbnailProps,
} from './ChatUploadingFileThumbnail';

import { ButtonVariant } from 'presentation/theme/components/button';

interface Props extends ChatUploadingFileThumbnailProps {
  name: string;
  size: number;
  error?: string;
  status: FileUploadingStatus;
  cancel: () => void;
}

const ChatUploadingFile: FC<Props> = ({
  name,
  status,
  error,
  size,
  repeat,
  cancel,
}) => {
  const { t } = useTranslation();

  return (
    <Box>
      <Flex py={3}>
        <Box mr={4}>
          <ChatUploadingFileThumbnail repeat={repeat} status={status} />
        </Box>
        <Box flex="1">
          <Text>{name}</Text>
          {status === FileUploadingStatus.failed && error ? (
            <Text fontSize="sm" color={Color.Error}>
              {error}
            </Text>
          ) : (
            <Text fontSize="sm" color="gray.400">
              {filesize(size, { base: 2 }) as string}
            </Text>
          )}
        </Box>
        <Box ml={2}>
          <IconButton
            size="sm"
            icon={<CloseIcon />}
            variant={ButtonVariant.Ghost}
            aria-label={t('cancel')}
            onClick={cancel}
          />
        </Box>
      </Flex>
      <Divider />
    </Box>
  );
};

export default ChatUploadingFile;
